<template>
  <div class="e4s-flex-column live-feed--wrapper e4s-full-height">
    <div v-for="message in getLiveFeedsToDisplay" :key="message.guid">
      <div class="fade-in-to-upper-right">
        <hr class="dat-e4s-hr-only dat-e4s-hr--light" />
        <div style="padding: var(--e4s-gap--standard) 0">
          <!--          ==============================-->
          <!--              <div class="e4s-flex-row e4s-gap&#45;&#45;standard">-->
          <!--                <div-->
          <!--                  class="e4s-flex-row e4s-gap&#45;&#45;standard e4s-flex-row&#45;&#45;end e4s-subheader&#45;&#45;general e4s-subheader&#45;&#45;300"-->
          <!--                >-->
          <!--                  <span>Received:</span>-->
          <!--                  <div v-text="message.displayTime"></div>-->
          <!--                </div>-->
          <!--              </div>-->
          <LiveFeedFieldResult
            :message="message as LiveFeedMessageBase"
            v-if="message.action === 'field-results' && message.payload"
          />

          <LiveFeedPfResult
            :message="message as LiveFeedMessageBase"
            v-if="message.action === 'photofinish'"
          />
          <LiveFeedManualEntry
            :message="message as LiveFeedMessageBase"
            v-if="message.action === 'results-manual'"
          />
          <!--          {{ message }}-->

          <LiveFeedFieldNextup
            :message="message as any as LiveFeedSocketMessage"
            v-if="message.action === 'field-nextup'"
          />

          <!--          <div v-if="message.action">{{ message.action }} {{ message.payload }}</div>-->

          <div
            class="e4s-flex-row e4s-text--small-light"
            style="margin-top: var(--e4s-gap--standard)"
          >
            <div v-text="message.displayTime"></div>
            <!--            <div v-text="message.guid" class="e4s-flex-row&#45;&#45;end"></div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, type PropType, ref, watch } from 'vue'
import type { LiveFeedMessageBase } from '@/components/results/socket/live-feed/live-feed-models'
import LiveFeedFieldResult from '@/components/results/socket/live-feed/ui/LiveFeedFieldResult.vue'
import LiveFeedPfResult from '@/components/results/socket/live-feed/LiveFeedPfResult.vue'
import LiveFeedManualEntry from '@/components/results/socket/live-feed/LiveFeedManualEntry.vue'
import type {
  FollowingEvents,
  StoreCompResultsState
} from '@/components/results/store-comp-results'
import { filterLiveFeedShowOnlyFollowing } from '@/components/results/results-service'
import type {
  ResultSocketActionType,
  SocketResultData
} from '@/components/results/socket/result-socket-models'
import * as LiveFeedService from '@/components/results/socket/live-feed/live-feed-service'
import type { SocketResultMessagePayloadFieldResults } from '@/components/results/socket/socket-field-results/socket-field-results-models'
import type { LiveFeedSocketMessage } from '@/components/results/socket/live-feed/models/live-feed-models'
import LiveFeedFieldNextup from '@/components/results/socket/live-feed/LiveFeedFieldNextup.vue'
import type { SocketResultMessagePayloadFieldNextup } from '@/components/results/socket/models/field-nextup'

const props = defineProps({
  storeCompResultsState: {
    type: Object as PropType<StoreCompResultsState>,
    required: true
  },
  liveFeed: {
    type: Array as PropType<LiveFeedSocketMessage[]>,
    required: true
  },
  followingEvents: {
    type: Object as PropType<FollowingEvents>,
    default: () => ({})
  }
})

const listToShow = ref<LiveFeedSocketMessage[]>([])
const showEverything = ref(false)

watch(
  () => props.liveFeed,
  (newVal, oldVal) => {
    listToShow.value = newVal
  },
  {
    immediate: true
  }
)

const getLiveFeedsToDisplay = computed<LiveFeedSocketMessage[]>(() => {
  if (showEverything.value) {
    return listToShow.value
  }

  const onlyCodedForNow = ['field-results', 'photofinish', 'results-manual', 'field-nextup']
  return listToShow.value.filter((message) => {
    return onlyCodedForNow.includes(message.action) && message.payload
  })
})

// function createList(socketResultsData: SocketResultData<unknown>[]) {
//   return socketResultsData.map((socketResultData) => {
//     return LiveFeedService.convertSocketResultDataToLiveFeedMessage(socketResultData)
//   })
// }

// const getLiveFeedsToDisplay = computed<SocketResultData<unknown>[]>(() => {
//   return filterLiveFeedShowOnlyFollowing(props.liveFeed, props.followingEvents)
//   return props.liveFeed
// })
</script>

<style scoped>
.fade-in-to-upper-right {
  animation-duration: 1s;
  animation-name: fade-in-to-upper-right;
}

@keyframes fade-in-to-upper-right {
  from {
    opacity: 0;
    height: 0;
    top: 350px;
    left: 0px;
    scale: 0;
  }

  to {
    opacity: 1;
    top: 0px;
    left: 350px;
    scale: 1;
  }
}

.fade-out-to-upper-right {
  animation-duration: 2s;
  animation-name: fade-out-to-upper-right;
}

@keyframes fade-out-to-upper-right {
  from {
    opacity: 1;
    top: 0px;
    left: 350px;
    scale: 1;
  }

  to {
    opacity: 0;
    height: 0;
    top: 350px;
    left: 0px;
    scale: 0;
  }
}
</style>
